import {useEffect, useRef, useState} from 'react';
import CardMenu from "../../components/card-menu";
import Menu from "./TopMenu";
import Alert from "../../components/alert";
import {segment_info, segment_limits} from "../../config/tips";
import Text from "../../components/input/text";
import Button from "../../components/button";
import UseGetFormData from "../../hooks/UseGetFormData";
import Checkbox from "../../components/input/checkbox";
import Number from "../../components/input/number";
import Icon from "../../components/icon";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Select from "../../components/input/select";
import {DELETE, GET, PATCH, POST, PUT} from "../../modules/workflow/components/Webservice/Methods";
import Code from "../../components/input/code";
import Builder from "../../components/input/query/builder";
import config from "../../components/input/query/segment";

const SegmentForm = (props) => {
    const {fields, segment, errors, audience, isReady, onSubmit} = props

    const formRef = useRef()
    const canvasRef = useRef()
    const [rules, setRules] = useState()


    const [limit, setLimit] = useState()
    const [useLimit, setUseLimit] = useState("off")
    const [useWsLimit, setUseWsLimit] = useState("off")
    const [showOptions, setShowOptions] = useState(false);
    const [wsMethod, setWsMethod] = useState("")
    const [wsEndpoint, setWsEndpoint] = useState("")
    const [wsHeaders, setWsHeaders] = useState("")
    const [wsBody, setWsBody] = useState("")
    const [hasCanvasError, setHasCanvasError] = useState(false)
    const AudienceMenu = Menu({audience: audience})


    const handleSubmit = (ev) => {
        ev.preventDefault()
        const FormData = UseGetFormData(formRef)

        onSubmit({
            name        : FormData.get('name'),
            config      : FormData.get('rules'),
            query       : FormData.get('query'),
            limit       : limit,
            endpoint    : wsEndpoint,
            headers     : wsHeaders,
            body        : wsBody,
            method      : wsMethod,
            use_limit   : useLimit,
            use_ws_limit: useWsLimit,
        })
    }


    const handleOffCanvasHide = (ev) =>{
        setShowOptions(false)
        const CanvasData = UseGetFormData(canvasRef)

        setLimit(CanvasData.get('limit'))
        setWsEndpoint(CanvasData.get('endpoint'))
        setWsBody(CanvasData.get('body'))
        setWsHeaders(CanvasData.get('headers'))
    }


    useEffect(() => {
        setRules(segment?.config)
        setUseLimit(segment?.use_limit ? "on" : "off")
        setUseWsLimit(segment?.use_ws_limit ? "on" : "off")
        setWsEndpoint(segment?.endpoint)
        setWsMethod(segment?.method)
        setWsHeaders(segment?.headers)
        setWsBody(segment?.body)
        setLimit(segment?.limit)


        let found = false
        errors && Object.keys(errors).map((key) => {
            if (["method", "endpoint", "headers", "body"].includes(key)) {
                found = true
            }
        })
        setHasCanvasError(found)

    }, [fields, segment, errors])


    return (
        <div>
            <form autoComplete="off" ref={formRef} onSubmit={handleSubmit}>
                <CardMenu {...AudienceMenu} />

                <Alert
                    icon="info"
                    docsPath="/docs/segments"
                    message={segment_info}
                />

                <Text required
                    size="md"
                    name="name"
                    label="Name"
                    isReady={isReady}
                    error={errors?.name}
                    value={segment?.name}
                    placeholder="Type segment name..."
                />


                <Builder required
                    size="md"
                    name="rules"
                    label="Rules"
                    value={rules}
                    queryName="query"
                    isReady={isReady}
                    error={errors?.rules}
                    config={config({fields: fields, audience: audience})}
                />


                <div className="d-flex align-items-center">
                    <div className="me-2">
                        <Button
                            size="sm"
                            color="primary"
                            isReady={isReady}
                            icon={segment ? 'check' : 'plus'}
                            label={segment ? 'Update' : 'Create'}
                        />
                    </div>
                    <div>
                        <a href="#more-options" onClick={ev => setShowOptions(true)}>
                            <Icon name="settings" style={{height: "16px", width: "16px"}}/>
                            {hasCanvasError && <Icon name="alert" className="ms-2 me-1 text-danger" style={{
                                height: "16px",
                                width : "16px"
                            }}/>}
                            <strong> Advanced Options</strong>
                        </a>
                    </div>
                </div>
            </form>

            <Offcanvas placement="end" show={showOptions} onHide={handleOffCanvasHide}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title as="h6">Advanced Options</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form autoComplete="off" ref={canvasRef}>

                        <Alert icon="info" message={segment_limits}/>

                        <div className="d-flex mb-4">
                            <div className="me-3">
                                <Checkbox
                                    name="use_limit"
                                    value={useLimit}
                                    isReady={isReady}
                                    label="Use static limit"
                                    onChange={ev => {
                                        setUseLimit(ev.target.checked ? "on" : "off")
                                        if (ev.target.checked) {
                                            setUseWsLimit("off")
                                        }
                                    }}
                                />
                            </div>

                            <div>
                                <Checkbox
                                    value={useWsLimit}
                                    name="use_ws_limit"
                                    isReady={isReady}
                                    label="Use ws limit"
                                    onChange={ev => {
                                        setUseWsLimit(ev.target.checked ? "on" : "off")
                                        if (ev.target.checked) {
                                            setUseLimit("off")
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        {useLimit === "on" && <Number
                            name="limit"
                            label="Limit"
                            value={limit}
                            isReady={isReady}
                            error={errors?.limit}
                            placeholder="Provide a limit"
                        />}


                        {useWsLimit === "on" && <>
                            <Select
                                name="method"
                                label="Method"
                                value={wsMethod}
                                isReady={isReady}
                                error={errors?.method}
                                placeholder="Choose a method"
                                options={[GET, PUT, POST, PATCH, DELETE]}
                                onChange={ev => setWsMethod(ev.value)}
                            />

                            <Text
                                name="endpoint"
                                label="Endpoint"
                                value={wsEndpoint}
                                isReady={isReady}
                                error={errors?.endpoint}
                                placeholder="https://api.com/v1"
                            />

                            <Code
                                name="headers"
                                label="Headers"
                                value={wsHeaders}
                                isReady={isReady}
                                error={errors?.headers}
                                placeholder="Json headers.."
                            />

                            <Code
                                name="body"
                                label="Body"
                                value={wsBody}
                                isReady={isReady}
                                error={errors?.body}
                                placeholder="Json body.."
                            />
                        </>}
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </div>
    )
}

export default SegmentForm;

